import { Observable } from 'rxjs';
import { ItokenFirebase } from '../../../../domain/interfaces/firebase/Itoken';

export abstract class FirebaseGatewayAbstract {

    abstract getToken(username: string): Observable<ItokenFirebase>;
}